import PropTypes from 'prop-types';
import styled from 'styled-components';
import { MaskMixin } from '../../mixins/components/MaskMixin';

/**
 * @related ['Modal']
 * @since 5.0.0
 */

var Mask = /*#__PURE__*/styled.div.withConfig({
  displayName: "Mask",
  componentId: "c11n-8-107-0__sc-1lyx31t-0"
})(["", ""], MaskMixin);
Mask.displayName = 'Mask';
Mask.propTypes = {
  /**
   * The mask is enabled by default, but you can disable it by setting this to false.
   * This can be used for blocking content until somebody takes an action.
   */
  enabled: PropTypes.bool
};
Mask.defaultProps = {
  enabled: true
};

/** @component */
export { Mask };